import React from 'react';
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons/faLocationArrow';

import styles from './allocatorProfileShowPageStyles';

import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import AllocatorProfileFundAdminDashboard from './AllocatorProfileFundAdminDashboard/allocatorProfileFundAdminDashboard';
import PageNavigator from 'buyside/components/presentation/PageNavigator/pageNavigator';
import AllocatorProfileSection from './AllocatorProfileSection/allocatorProfileSection';
import ProfileHeader, {
  PROFILE_TYPES
} from 'buyside/components/presentation/ProfileHeader/profileHeader';

import {
  SECTIONS,
  ICONS,
  TITLES,
  MINIMUM_ATTRIBUTES,
  EMPTY_TEXT,
  COMPONENTS,
  EDIT_FORMS,
  EDIT_FORM_BOX_TEXT,
  VALIDATION_SCHEMATA
} from 'buyside/util/allocatorProfileConstants';

const AllocatorProfileShowPage = ({
  loading,
  currentUser,
  allocatorProfile,
  updateBackgroundImage,
  updateAllocatorProfile
}) => {
  if (loading) {
    return <LoadingSpinner size="large" />;
  } else {
    const { isAllocatorAdmin, adminFunds, isAllocator } = currentUser;
    const {
      allocatorRecommendation,
      aumRange,
      bio,
      employerType,
      fundManager,
      id: allocatorProfileId,
      location,
      name,
      publicBio,
      recentlyJoined,
      undisclosed
    } = allocatorProfile;
    const attrExists = attr =>
      Array.isArray(allocatorProfile[attr])
        ? !!allocatorProfile[attr].length
        : !!allocatorProfile[attr];
    const isEmpty = section => !MINIMUM_ATTRIBUTES[section].some(attr => attrExists(attr));
    const isHidden = section => !isAllocatorAdmin && isEmpty(section);
    const mainDatapoints = [{ title: location, icon: faLocationArrow }];
    const datapoints = [
      {
        title: 'AUM',
        value: aumRange ? (undisclosed ? 'Withheld' : aumRange) : 'N/A'
      },
      { title: 'Type', value: employerType || 'N/A' },
      { title: 'Managed By', value: fundManager || 'N/A' }
    ];

    const currentUserHasActiveFundProfile = !isAllocator && adminFunds.length > 0;

    return (
      <>
        <ProfileHeader
          datapoints={datapoints}
          displayName={
            name ||
            `${location ? location : 'N/A'}-Based ${aumRange ? aumRange : ''} ${
              employerType ? employerType : 'N/A'
            }`
          }
          mainDatapoints={mainDatapoints}
          profile={allocatorProfile}
          profileType={PROFILE_TYPES.ALLOCATOR}
          roleIsAdmin={isAllocatorAdmin}
          recommendation={
            currentUserHasActiveFundProfile &&
            allocatorRecommendation &&
            !allocatorRecommendation.hide
              ? allocatorRecommendation
              : null
          }
          saveBackgroundImage={updateBackgroundImage}
          summaryHtml={!bio && publicBio ? publicBio : bio}
          updateCard={({ allocatorProfile }) =>
            updateAllocatorProfile({ allocatorProfile, section: 'card' })
          }
        />
        <PageNavigator
          fullWidth
          items={SECTIONS.filter(section => !isHidden(section)).map(section => ({
            label: TITLES[section],
            id: section
          }))}
        />
        {currentUserHasActiveFundProfile && (
          <AllocatorProfileFundAdminDashboard
            adminFunds={adminFunds}
            allocatorProfileId={allocatorProfileId}
            allocatorRecentlyJoined={recentlyJoined}
          />
        )}
        {SECTIONS.filter(section => !isHidden(section)).map((section, idx) => {
          return (
            <section key={idx} className={styles.profileSection} id={section}>
              <AllocatorProfileSection
                section={section}
                isAdmin={isAllocatorAdmin}
                allocatorProfile={allocatorProfile}
                icon={ICONS[section]}
                title={TITLES[section]}
                sectionEmpty={isEmpty(section)}
                emptyText={EMPTY_TEXT[section] || EMPTY_TEXT.default}
                component={COMPONENTS[section]}
                editForm={EDIT_FORMS[section]}
                editFormBoxText={EDIT_FORM_BOX_TEXT[section]}
                validationSchema={VALIDATION_SCHEMATA[section]}
                updateAllocatorProfile={updateAllocatorProfile}
              />
            </section>
          );
        })}
      </>
    );
  }
};

export default AllocatorProfileShowPage;
